<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="stocktakingMonth"
                label="棚卸年月"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="monthForPicker"
              type="month"
              @input="menu = false"
              locale="jp-ja"
              no-title
              scrollable
              @change="onChangeMonth()"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            棚卸在庫日の設定
          </v-card-title>
          <v-layout row align-content-center>
            <v-flex xs5>
              <v-menu
                v-model="stocktakingMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="stocktakingDate"
                    label="棚卸在庫日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    :disabled="disableStocktakingDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateForPicker"
                  type="date"
                  @input="stocktakingMenu = false"
                  locale="jp-ja"
                  :day-format="date => new Date(date).getDate()"
                  no-title
                  scrollable
                  :min="minDate"
                  :max="maxDate"
                  @change="onChangeDate()"
                >
                  <v-spacer></v-spacer>
                </v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs2></v-flex>
            <v-flex xs5 align-self-center>
              <v-btn v-if="!disableStocktakingDate"
                block
                color="warning"
                dark
                @click="registStocktakingDate()"
              >
                <v-icon dark left></v-icon>設定
              </v-btn>
              <v-btn v-else
                block
                color="red"
                dark
                @click="deleteStocktakingDate()"
              >
                <v-icon dark left></v-icon>{{ $t('delete-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            店舗
          </v-card-title>
          <v-layout row wrap reverse>
            <v-flex sm2 align-self-center>
              <v-btn block color="info" @click="getStoreStocktaking()">
                <v-icon left>update</v-icon>{{ $t('update-btn') }}
              </v-btn>
            </v-flex>

            <div style="width: 10px;"></div>

            <v-flex sm2 align-self-center>
              <v-btn block color="warning" v-bind:disabled="applyFlg">
                <v-icon left>save</v-icon>店舗在庫に反映
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-select
                v-model="selectSupplier"
                :items="suppliers"
                item-text="supplierName"
                item-value="supplierCode"
                return-object
                clearable
                label="取引先"
              ></v-select>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="stores"
              hide-actions
              class="elevation-1"
              :customFilter="customFilter"
              :custom-sort="customSort"
              :search="selectSupplier"
              style="width: 100%; margin: 15px 0 0;"
              :no-data-text="$t('noTableDataAvailable')"
              :loading="storeDataLoading"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <tr v-bind:class="{'active-class-name': '1' === props.item.status }" >
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.storeName }}
                  </td>
                  <td
                    class="text-xs-center"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    <v-icon
                      v-if="props.item.expirationDateFlg == '1'"
                      color="error"
                      >check_circle</v-icon
                    >
                  </td>
                  <td
                    class="text-xs-center"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    <v-icon v-if="props.item.oldDesignFlg == '1'" color="error"
                      >check_circle</v-icon
                    >
                  </td>
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.createdAt }}
                  </td>
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.createdUser }}
                  </td>
                  <td class="text-xs-left pa-1">
                    <v-btn
                      block
                      color="error"
                      dark
                      :disabled="!props.item.createdAt"
                      @click="deleteDialog(props.item)"
                      class="ma-0"
                    >
                      <v-icon dark left>delete_forever</v-icon>{{ $t('delete-btn') }}
                    </v-btn>
                  </td>                 
                </tr>
              </template>
            </v-data-table>
          </v-layout>

          <div style="height: 10px;"></div>

          <!-- 버튼 영역 -->
          <div class="footer-btns">
            <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
              <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
            </v-btn>
            <v-btn block color="info" dark @click="downloadCsv()">
              <v-icon dark left>get_app</v-icon>棚卸データダウンロード
            </v-btn>
          </div>

        </v-container>
      </v-card>
    </v-container>

    <!-- 삭제 버튼 눌렀을때 다이알 로그 -->
    <v-dialog max-width="300px" v-model="dispDeleteDialog">
      <!-- v-model="dialog1" -->
      <v-card>
        <v-container>
          <v-card-title>
            <span style="margin: 0 auto 0;">{{ $t('delete-btn') }}しますか</span>
          </v-card-title>
          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn color="error" text @click="deleteStocktaking()"
                >{{ $t('delete-btn') }}</v-btn
              >
              <v-btn text @click.stop="dispDeleteDialog = false">{{ $t('back-btn') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import moment from 'moment-timezone'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    this.minDate = moment().format('YYYY-MM-DD')
    this.maxDate = moment()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (!this.stocktakingMonth) {
      this.$store.commit(
        'SET_STOCK_MANAGEMENT_SELECTED_MONTH',
        moment().format('YYYY/MM')
      )
    }

    // 1. 棚卸日のデータ取得
    this.getStocktakingDate()
    // 2. 店舗データ取得
    this.getStoreStocktaking()
  },
  computed: {
    stocktakingMonth: {
      get() {
        return this.$store.state.adminSession.stockManagementSelectedMonth
      },
      set(value) {
        this.$store.commit('SET_STOCK_MANAGEMENT_SELECTED_MONTH', value)
      }
    }
  },
  methods: {
    getStocktakingDate() {
      console.log('getStocktakingDate')

      let request = {
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
      }

      this.stocktakingDate = ''

      ServerApiCallService.getStocktakingDate(request)
        .then(response => {
          if (response.data.stocktakingDateSetting.stocktakingDate) {
            this.stocktakingDate =
              response.data.stocktakingDateSetting.stocktakingDate
            this.stocktakingDate = moment(
              this.stocktakingDate,
              'YYYY-MM-DD'
            ).format('MM/DD')
            // 삭제할때 사용할 6자리의 날짜
            this.delStocktakingDate = response.data.stocktakingDateSetting.stocktakingDate

            this.disableStocktakingDate = true
          } else {
            this.stocktakingDate = ''
            this.disableStocktakingDate = false
          }

          if (
            moment(this.stocktakingMonth, 'YYYY-MM-DD').month() <
            moment().month()
          ) {
            this.disableStocktakingDate = true
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    getStoreStocktaking() {
      console.log('getStoreStocktaking')

      this.storeDataLoading = true

      let request = {
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
      }

      ServerApiCallService.getStoreStocktaking(request)
        .then(response => {
          this.stores = response.data.stocktakingList
          this.stores.forEach(item => {
            if (item.createdAt) {
              item.createdAt = moment(item.createdAt).format('MM/DD HH:mm')
            }
          })

          this.suppliers = response.data.stocktakingList
          // this.applyFlg = response.data.applied

          this.storeDataLoading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    onChangeMonth() {
      console.log('onChangeMonth')

      this.stocktakingMonth = this.monthForPicker.replace(/-/g, '/')

      this.minDate = moment(this.monthForPicker, 'YYYY-MM-DD').format(
        'YYYY-MM-DD'
      )
      this.maxDate = moment(this.monthForPicker, 'YYYY-MM-DD')
        .endOf('month')
        .format('YYYY-MM-DD')

      if (
        moment(this.stocktakingMonth, 'YYYY-MM-DD').month() == moment().month()
      ) {
        this.minDate = moment().format('YYYY-MM-DD')
      }

      this.getStocktakingDate()
      this.getStoreStocktaking()
    },
    onChangeDate() {
      this.stocktakingDate = this.dateForPicker.replace(/-/g, '/')
    },
    registStocktakingDate() {
      console.log('regist stocktaking date')

      let request = {
        stocktakingDate: this.stocktakingDate.replace(/\//g, '')
      }

      ServerApiCallService.registStocktakingDate(request)
        .then(response => {
          this.getStocktakingDate()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
          this.getStocktakingDate()
        })
    },
    deleteStocktakingDate() {
      console.log('delete stocktaking date')

      if(!this.stocktakingDate) {
        alert("棚卸日が登録されてないです")
        return
      }

      console.log("this.stocktakingDate: ", this.stocktakingDate);      
      console.log("this.delStocktakingDate: ", this.delStocktakingDate);      
      
      let request = {
        stocktakingDate: this.delStocktakingDate
      }

      ServerApiCallService.deleteStocktakingDate(request)
        .then(response => {
          this.getStocktakingDate()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
          this.getStocktakingDate()
        })
    },
    customFilter(items, search) {
      console.log('custom filter')

      if (!search.supplierCode) {
        return items
      } else {
        let filteringItems = items.filter(function(item) {
          if (item.supplierCode === search.supplierCode) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (!isDesc) {
          if (a.storeName < b.storeName) {
            return -1
          } else if (a.storeName > b.storeName) {
            return 1
          }
        } else {
          if (a.storeName < b.storeName) {
            return 1
          } else if (a.storeName > b.storeName) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    deleteDialog(selectedStocktaking) {
      console.log('deleteDialog')
      this.selectedStocktaking = selectedStocktaking
      this.dispDeleteDialog = true
    },
    deleteStocktaking() {
      console.log('deleteStocktaking')

      let request = {
        storeCode: this.selectedStocktaking.storeCode,
        stocktakingMonth: this.selectedStocktaking.stocktakingMonth
      }

      ServerApiCallService.deleteStoreStocktaking(request)
        .then(response => {
          this.dispDeleteDialog = false
          this.getStoreStocktaking()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
          this.getStoreStocktaking()
        })
    },
    forwardStockManagementDetail(selectedStore) {
      console.log('deleteStocktaking')

      if (!selectedStore.createdAt) {
        console.log('regist stocktaking')
        this.$router.push({
          name: 'admin/stocktakingRegist',
          params: {
            storeCode: selectedStore.storeCode,
            storeName: selectedStore.storeName,
            stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
          }
        })
      } else {
        console.log('stocktaking detail')
        this.$router.push({
          name: 'admin/stockManagementDetail',
          params: {
            storeCode: selectedStore.storeCode,
            storeName: selectedStore.storeName,
            stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
          }
        })
      }
    },
    downloadCsv() {
      let request = {
        supplierCode: this.selectSupplier.supplierCode,
        stocktakingMonth: this.stocktakingMonth.replace(/\//g, '')
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/stocktaking-download', request, {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '店舗棚卸在庫.csv'
          link.click()
        })
    }
  },
  data() {
    return {
      applyFlg: true,
      selectedStocktaking: '',
      dispDeleteDialog: false,
      storeDataLoading: false,
      disableStocktakingDate: true,
      menu: false,
      stocktakingMenu: false,
      monthForPicker: '',
      dateForPicker: '',
      minDate: '',
      maxDate: '',
      stocktakingDate: '',
      delStocktakingDate: '',
      selectSupplier: [],
      suppliers: [],
      warehouseHeaders: [
        {
          text: '倉庫名',
          align: 'left',
          value: 'warehouseName',
          sortable: false,
          fixed: false
        },
        {
          text: '棚卸済',
          align: 'left',
          value: 'status',
          sortable: false,
          fixed: false
        },
        {
          text: '登録日',
          align: 'left',
          value: 'createdAt',
          sortable: false,
          fixed: false
        }
      ],
      warehouses: [
        {
          warehouseName: '三田',
          status: '0',
          createdAt: ''
        },
        {
          warehouseName: '千葉',
          status: '1',
          createdAt: '2019/1/20'
        }
      ],
      headers: [
        {
          text: '店舗名',
          align: 'left',
          value: 'storeName',
          width: '30%',
          sortable: false,
          fixed: false
        },
        {
          text: '賞味期限切れ',
          align: 'center',
          value: 'expirationDateFlg',
          sortable: false,
          fixed: false
        },
        {
          text: '旧デザイン商品',
          align: 'center',
          value: 'oldDesignFlg',
          sortable: false,
          fixed: false
        },
        {
          text: '確定日時',
          align: 'left',
          value: 'createdAt',
          sortable: false,
          fixed: false
        },
        {
          text: '確定者',
          align: 'left',
          value: 'createdUser',
          sortable: false,
          fixed: false
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'delete',
          width: '20px'
        }
      ],
      stores: []
    }
  }
}
</script>
<style>
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.active-class-name {
  background-color: #d5ffc4;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
